<template>
  <div class="modal fleet-delete">
    <div class="modal__wrapper">
      <div class="modal__close" @click="$emit('close-modal')">
        <fa-icon icon="times"></fa-icon>
      </div>
      <div class="modal__title">Voertuig verwijderen</div>
      <div class="modal__body">
        <p>Ben je zeker dat je het voertuig wenst te verwijderen?</p>
      </div>
      <div class="modal__controls">
        <button class="button button--cancel" @click="$emit('delete-decline')">Nee</button>
        <button class="button button--accept" @click="$emit('delete-confirm')">Ja</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "FleetDelete"
}
</script>
